import React, {Fragment} from 'react';
import {TMatchPlayer} from '@chancer/common/lib/interfaces/firestore/LeaguesInterfaces';
import {
  CollapsableCard,
  FormSection,
  FormSectionItem,
} from '../../../components/Form/FormSection';
import {Input} from '../../../components/Form/FormElements';

interface IPlayersTokenEditorProps {
  minLength?: number;
  homeTeamCode: string;
  homeTeamPlayers: TMatchPlayer[];
  awayTeamCode: string;
  awayTeamPlayers: TMatchPlayer[];
  onChange: (
    homeTeamCode: string,
    homeTeamPlayers: TMatchPlayer[],
    awayTeamCode: string,
    awayTeamPlayers: TMatchPlayer[],
  ) => void;
}

export const PlayersTokenEditor: React.FC<IPlayersTokenEditorProps> = (
  props,
) => {
  const {minLength = 1} = props;
  const homeTeamPlayers = [...props.homeTeamPlayers];
  const awayTeamPlayers = [...props.awayTeamPlayers];

  if (homeTeamPlayers.length < minLength) {
    for (let i = homeTeamPlayers.length; i < minLength; i++) {
      homeTeamPlayers.push({
        id: `hp-id-${i}`,
        name: `Player ${i + 1}`,
        averageScore: 0,
        lastScore: 0,
        countryCode: '',
      });
    }
  }
  if (awayTeamPlayers.length < minLength) {
    for (let i = awayTeamPlayers.length; i < minLength; i++) {
      awayTeamPlayers.push({
        id: `ap-id-${i}`,
        name: `Player ${i + 1}`,
        averageScore: 0,
        lastScore: 0,
        countryCode: '',
      });
    }
  }

  const homeTeam =
    homeTeamPlayers.length > 0 ? (
      <FormSectionItem key="home" columnSpan="6">
        <CollapsableCard
          compressed={true}
          isOpen={false}
          title="Home Team Players">
          <FormSection>
            <Input
              columnSpan="4"
              label="Team Code"
              inputProps={{
                id: 'home-team-code',
                placeholder: 'Team code',
                defaultValue: props.homeTeamCode,
                onChange: (e) => {
                  props.onChange(
                    e.target.value,
                    homeTeamPlayers,
                    props.awayTeamCode ?? '',
                    awayTeamPlayers,
                  );
                },
              }}
            />
            {homeTeamPlayers.map((player, index) => (
              <RenderPlayerRow
                key={player.id}
                player={player}
                onChange={(player) => {
                  const players = [
                    ...homeTeamPlayers.slice(0, index),
                    player,
                    ...homeTeamPlayers.slice(index + 1),
                  ];
                  props.onChange(
                    props.homeTeamCode ?? '',
                    players,
                    props.awayTeamCode ?? '',
                    awayTeamPlayers,
                  );
                }}
              />
            ))}
          </FormSection>
        </CollapsableCard>
      </FormSectionItem>
    ) : null;
  const awayTeam =
    awayTeamPlayers.length > 0 ? (
      <FormSectionItem key="away" columnSpan="6">
        <CollapsableCard
          compressed={true}
          isOpen={false}
          title="Away Team Players">
          <FormSection>
            <Input
              columnSpan="4"
              label="Team Code"
              inputProps={{
                id: 'away-team-code',
                placeholder: 'Team code',
                defaultValue: props.awayTeamCode,
                onChange: (e) => {
                  props.onChange(
                    props.homeTeamCode ?? '',
                    homeTeamPlayers,
                    e.target.value,
                    awayTeamPlayers,
                  );
                },
              }}
            />
            {awayTeamPlayers.map((player, index) => (
              <RenderPlayerRow
                key={player.id}
                player={player}
                onChange={(player) => {
                  const players = [
                    ...awayTeamPlayers.slice(0, index),
                    player,
                    ...awayTeamPlayers.slice(index + 1),
                  ];
                  props.onChange(
                    props.homeTeamCode ?? '',
                    homeTeamPlayers,
                    props.awayTeamCode ?? '',
                    players,
                  );
                }}
              />
            ))}
          </FormSection>
        </CollapsableCard>
      </FormSectionItem>
    ) : null;

  return (
    <>
      {homeTeam}
      {awayTeam}
    </>
  );
};

interface IPlayerRowProps {
  player: TMatchPlayer;
  onChange: (player: TMatchPlayer) => void;
}

const RenderPlayerRow: React.FC<IPlayerRowProps> = (props) => {
  const {player, onChange} = props;
  return (
    <Fragment>
      <Input
        columnSpan="3"
        label="Name"
        inputProps={{
          id: `home-${player.id}-name`,
          placeholder: 'Player name',
          defaultValue: player.name,
          onChange: (e) => {
            onChange({...player, name: e.target.value});
          },
        }}
      />
      <Input
        columnSpan="1"
        label="ID"
        inputProps={{
          id: `home-${player.id}-id`,
          placeholder: 'Player Id',
          defaultValue: player.id,
          onChange: (e) => {
            onChange({...player, id: e.target.value});
          },
        }}
      />
      <Input
        columnSpan="1"
        label="Average"
        inputProps={{
          id: `home-${player.id}-average`,
          placeholder: 'Average',
          defaultValue: player.averageScore,
          onChange: (e) => {
            onChange({...player, averageScore: parseFloat(e.target.value)});
          },
        }}
      />
      <Input
        columnSpan="1"
        label="Last Score"
        inputProps={{
          id: `home-${player.id}-average`,
          placeholder: 'Last Score',
          defaultValue: player.lastScore,
          onChange: (e) => {
            onChange({...player, lastScore: parseFloat(e.target.value)});
          },
        }}
      />
    </Fragment>
  );
};
